import React, { useState, useEffect, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Form } from "react-bootstrap";
import WeekSelector from "../weekSelector";
import DriverSelector from "../../components/driverSelector";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { useTranslation } from 'react-i18next';
import { useLocation } from "react-router-dom";

// 🔹 Переконуємося, що `pdfFonts` містить `vfs`
if (pdfFonts && pdfFonts.vfs) {
    pdfMake.vfs = pdfFonts.vfs;
    console.log("✅ Шрифти pdfMake завантажені успішно.");
} else {
    console.error("❌ Помилка завантаження шрифтів pdfMake! Шрифти не ініціалізовані.");
}

const DriverRaport = () => {
    const { t } = useTranslation();

    const [weekNumber, setWeekNumber] = useState(null);
    const [selectedUser, setSelectedUser] = useState(null);
    const [users, setUsers] = useState([]);
    const [reportData, setReportData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [debts, setDebts] = useState([]); // Збереження списку боргів
    const [showDebtModal, setShowDebtModal] = useState(false);
    const [selectedDebts, setSelectedDebts] = useState([]); // Список обраних боргів
    const [finalData, setFinalData] = useState([]);
    const [totalDebt, setTotalDebt] = useState(0); // Загальна сума вибраних боргів
    const [extraFunds, setExtraFunds] = useState({});
    const [hasExtraFunds, setHasExtraFunds] = useState(null); // ✅ Стан для відображення повідомлення

    const firstRender = useRef(true); // ✅ Оголошуємо useRef всередині функції
    useEffect(() => {
        console.log("🔍 Виконується запит на отримання користувачів...");

        fetch("https://godrive.com.pl/api/users")
            .then(response => response.json())
            .then(data => {
                console.log("📋 Отримані користувачі:", data);
                setUsers(data);
            })
            .catch(error => console.error("❌ Помилка завантаження користувачів:", error));
    }, []);
    const location = useLocation();

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const driverId = queryParams.get("driverId");
        const week = queryParams.get("week");

        if (driverId && users.length > 0) {
            const user = users.find(u => u.id === parseInt(driverId));
            if (user) {
                setSelectedUser({ value: user.id, label: `${user.firstName} ${user.lastName}` });
                setWeekNumber(Number(week));
            }
        }
    }, [users, location.search]);


    const fetchReport = async () => {
        if (!weekNumber || !selectedUser) {
            console.warn("⚠️ Не всі дані введені! Номер тижня:", weekNumber, "Користувач:", selectedUser);
            return;
        }

        console.log(selectedUser.label);
        const [firstName, lastName] = selectedUser.label.split(" ");

        setLoading(true);
        try {
            const response = await fetch("https://godrive.com.pl/api/new-raport/", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    week_number: weekNumber,
                    first_name: firstName,
                    last_name: lastName,
                }),
            });

            if (!response.ok) {
                throw new Error(`HTTP помилка! Статус: ${response.status}`);
            }

            const data = await response.json();
            console.log("📊 Отримані дані рапорту:", data);
            console.log("🚖 Uber дані:", data.uber);
            console.log("🚗 Bolt дані:", data.bolt);
            console.log("🚕 FreeNow дані:", data.freenow);

            setReportData(data);
            checkDebts(selectedUser.value); // Передаємо user_id у checkDebts
            fetchExtraFunds(selectedUser.value, weekNumber);

        } catch (error) {
            console.error("❌ Помилка під час отримання рапорту:", error);
        } finally {
            setLoading(false);
        }

    };

    const fetchExtraFunds = async (driverId, weekNumber) => {
        try {
            const response = await fetch(`https://godrive.com.pl/api/extra-funds-raport?driver_id=${driverId}&week_number=${weekNumber}`);
            if (!response.ok) throw new Error("Помилка отримання extra funds");

            const data = await response.json();
            console.log("📊 Отримані дані extra funds:", data);
            setExtraFunds(data);

            // ✅ Коректна перевірка наявності даних
            const hasData = Object.values(data).some(value => value !== null && value !== 0 && value !== "");

            setHasExtraFunds(hasData);
        } catch (error) {
            console.error("Помилка під час отримання extra funds:", error);
            setHasExtraFunds(false);
        }
    };

    // перевіряємо чи є борги
    const checkDebts = async (driverId) => {
        if (!driverId) {
            console.warn("⚠️ Не передано ID водія для перевірки боргів.");
            return;
        }

        try {
            const response = await fetch(`https://godrive.com.pl/api/drivers-debts?driver_id=${driverId}`);
            if (!response.ok) {
                throw new Error(`HTTP помилка! Статус: ${response.status}`);
            }

            const debtsData = await response.json();
            console.log("💳 Отримані борги:", debtsData);

            // ✅ Фільтруємо тільки активні борги (де debt_status = "open")
            const activeDebts = debtsData.filter(debt => debt.debt_status === "open");

            setDebts(activeDebts.map(debt => ({
                ...debt,
                debt_total: Number(debt.debt_total) || 0
            })));

            if (activeDebts.length > 0) {
                setShowDebtModal(true);
            }
        } catch (error) {
            console.error("❌ Помилка при отриманні боргів:", error);
        }
    };
    // робота з боргами у модальному вікні
    const toggleDebtSelection = (debt) => {
        setSelectedDebts((prev) => {
            if (prev.includes(debt.id)) {
                return prev.filter((id) => id !== debt.id);
            } else {
                return [...prev, debt.id];
            }
        });
    };

    const applySelectedDebts = () => {
        const selectedDebtsData = debts.filter((debt) => selectedDebts.includes(debt.id));
        const total = selectedDebtsData.reduce((sum, debt) => sum + debt.debt_total, 0);

        setTotalDebt(total);

        setFinalData((prev) => {
            const newData = prev.filter(item => item.name !== "Відняті борги");
            if (total > 0) {
                newData.push({ name: "Відняті борги", value: `-${total.toFixed(2)}` });
            }
            return newData;
        });

        setShowDebtModal(false);
    };

    // Глобально доступні податки та загалом сума
    const [taxData, setTaxData] = useState({
        uber: { tax: 0, total: 0 },
        bolt: { tax: 0, total: 0 },
        freenow: { tax: 0, total: 0 }
    });

    // Тут все обрахуємо
    const calculateTaxAndTotal = (data, service) => {
        if (!data || data.length === 0) return { tax: 0, total: 0 };

        let tax = 0;
        let total = 0;

        switch (service) {
            case "uber":
                // Для Uber: Податок 4% від incBrutto
                let incBruttoUber = parseFloat(data[0]?.incBrutto) || 0;
                let incNetto = parseFloat(data[0]?.incNetto) || 0;

                tax = incBruttoUber * 0.04;

                total = incNetto - tax;
                break;

            case "bolt":
                // Для Bolt: Податок 4% від incBruttoBolt, загальний дохід inc_netto - податок
                let incBruttoBolt = parseFloat(data[0]?.incBrutto) || 0;
                let totalInc = parseFloat(data[0]?.totalInc) || 0;
                tax = incBruttoBolt * 0.04;
                total = totalInc - tax;
                console.log(`total bolt: ${totalInc} - ${tax} = ${total}`);
                break;

            case "freenow":
                // Для FreeNow: Податок 4% від brutto, загальний дохід inc_netto - податок - app_fee
                let brutto = parseFloat(data[0]?.brutto) || 0;
                let saldo_freenow = parseFloat(data[0]?.saldo_freenow) || 0;
                tax = brutto * 0.04;
                total = saldo_freenow - tax;
                break;

            default:
                break;
        }

        return { tax, total };
    };

    // 🔹 Поля, які будемо показувати для кожного сервісу
    const selectedFields = {
        uber: ["incBrutto", "incNetto", "appFee", "appFeeTaxes", "incCash", "tips", "bonus"],
        bolt: ["incBrutto", "totalInc", "incNettoCash", "tips", "bonus"],
        freenow: ["brutto", "saldo_freenow", "cash", "tips", "bonus"]
    };

    // 🔹 Словник для відображення назв колонок у таблиці
    const columnNames = {
        uber: {
            incBrutto: t("brutto"),
            appFee: `Uber ${t("fee").toLocaleLowerCase()}`,
            appFeeTaxes: `Uber ${t("taxes").toLocaleLowerCase()}`,
            incCash: t("cash"),
            tips: t("tips"),
            bonus: t("bonus"),
            incNetto: `Uber ${t("balance").toLocaleLowerCase()}`
        },
        bolt: {
            incBrutto: t("brutto"),
            totalInc: `Bolt ${t("balance").toLocaleLowerCase()}`,
            bonus: t("bonus"),
            incNettoCash: t("cash"),
            tips: t("tips")
        },
        freenow: {
            brutto: t("brutto"),
            cash: t("cash"),
            saldo_freenow: `FreeNow ${t("balance").toLocaleLowerCase()}`,
            tips: t("tips"),
            bonus: t("bonus"),

        },
    };

    // 🔹 Поля, до яких треба додати "-"
    const negativeFields = {
        bolt: ["app_fee", "saldo"],
        extraFunds: ["taxesZUS", "partner", "accountant", "carRent", "other"] // Додаємо extra_funds
    };

    // додаємо податки та загалом у таблицю
    useEffect(() => {
        if (reportData) {
            setTaxData({
                uber: calculateTaxAndTotal(reportData.uber, "uber"),
                bolt: calculateTaxAndTotal(reportData.bolt, "bolt"),
                freenow: calculateTaxAndTotal(reportData.freenow, "freenow"),
            });
        }
    }, [reportData]);

    const fieldsForPDF = {
        uber: ["incBrutto", "incNetto", "incCash", "tips", "bonus"],
        bolt: ["incBrutto", "totalInc", "incNettoCash", "tips", "bonus"],
        freenow: ["brutto", "saldo_freenow", "cash", "tips", "bonus"],
        extraFunds: ["returnVAT", "taxesZUS", "partner", "accountant", "carRent", "other", "sallary", "refunds"],
        final: ["PayOut"]
    };

    const customColumnNames = {
        uber: {
            incBrutto: t("brutto"),
            incNetto: `Uber ${t("payment").toLocaleLowerCase()}`,
            appFee: `Uber ${t("fee").toLocaleLowerCase()}`,
            appFeeTaxes: `Uber ${t("taxes").toLocaleLowerCase()}`,
            incCash: t("cash"),
            tips: t("tips"),
            bonus: t("bonus"),
        },
        bolt: {
            incBrutto: t("brutto"),
            totalInc: `Bolt ${t("payment").toLocaleLowerCase()}`,
            bonus: t("bonus"),
            incNettoCash: t("cash"),
            tips: t("tips"),

        },
        freenow: {
            brutto: t("brutto"),
            cash: t("cash"),
            saldo_freenow: `FreeNow ${t("payment").toLocaleLowerCase()}`,
            tips: t("tips"),
            bonus: t("cash"),
        },
        extraFunds: {
            returnVAT: `${t("return")} ${t("vat")}`,
            taxesZUS: `${t("taxes")} ${t("zus")}`,
            partner: `${t("partner")} ${t("fee").toLocaleLowerCase()}`,
            accountant: t("accountant"),
            carRent: t("carRent"),
            other: t("otherCosts"),
            sallary: t("sallary"),
            refunds: t("refunds"),
        },
        final: {
            Debt: `${t("total")} ${t("debt").toLocaleLowerCase()}`,
            PayOut: `${t("total")} ${t("payment").toLocaleLowerCase()}`,
        }
    };

    const downloadPDF = () => {
        if (!selectedUser || !weekNumber) {
            console.warn("⚠️ Виберіть водія та номер тижня перед збереженням PDF.");
            return;
        }

        if (!reportData) {
            console.error("❌ Дані звіту не отримані! Переконайтеся, що ви згенерували звіт перед завантаженням PDF.");
            return;
        }

        const parseOtherExpenses = (otherExpenses) => {
            if (!otherExpenses || !Array.isArray(otherExpenses)) return {}; // Якщо null або не масив → повертаємо порожній об'єкт

            return otherExpenses.reduce((acc, item) => {
                if (item.description && item.amount) {
                    acc[item.description] = parseFloat(item.amount) || 0; // Перетворюємо у число
                }
                return acc;
            }, {});
        };

        const otherExpenses = parseOtherExpenses(extraFunds.other_expenses);

        // 🔹 Оновлюємо `finalData` перед створенням PDF
        const boltTotal = taxData.bolt.total || 0;
        const uberTotal = taxData.uber.total || 0;
        const freenowTotal = taxData.freenow.total || 0;

        const payout =
            (boltTotal || 0) +
            (uberTotal || 0) +
            (freenowTotal || 0) -
            (parseFloat(totalDebt)) +
            (parseFloat(extraFunds.returnVAT) || 0) -
            ((parseFloat(extraFunds.taxesZUS) || 0) +
                (parseFloat(extraFunds.partner) || 0) +
                (parseFloat(extraFunds.accountant) || 0) +
                (parseFloat(extraFunds.carRent) || 0) +
                (parseFloat(extraFunds.sallary) || 0) +
                (parseFloat(extraFunds.other) || 0) -
                (parseFloat(extraFunds.refunds) || 0));

        const updatedFinalData = [
            { name: "Bolt", value: boltTotal.toFixed(2) },
            { name: "Uber", value: uberTotal.toFixed(2) },
            { name: "FreeNow", value: freenowTotal.toFixed(2) },
            { name: `${t("return")} ${t("vat")}`, value: extraFunds.returnVAT, description: "повернення VAT / zwrot VAT / возврат VAT" },
            { name: `${t("taxes")} ${t("zus")}`, value: extraFunds.taxesZUS ? `-${extraFunds.taxesZUS}` : "0", description: "податки + ЗУС / podatki + ZUS / налоги + ЗУС" },
            { name: t("partner"), value: extraFunds.partner ? `-${extraFunds.partner}` : "0", description: "партнер / partner / партнер" },
            { name: t("accountant"), value: extraFunds.accountant ? `-${extraFunds.accountant}` : "0", description: "бухгалтер / księgowy / бухгалтер" },
            { name: t("carRent"), value: extraFunds.carRent ? `-${extraFunds.carRent}` : "0", description: "оренда авто / wynajem samochodu / аренда авто" },
            {
                name: [
                    t("other"),
                    ...Object.entries(otherExpenses).map(([desc, amount]) => `${desc}: ${amount} PLN`)
                ],
                value: `-${extraFunds.other || 0}`
            },

            { name: t("refunds"), value: extraFunds.refunds ? `${extraFunds.refunds}` : "0", description: "повернення / zwrot / возврат" },
            { name: t("sallary"), value: extraFunds.sallary ? `${extraFunds.sallary}` : "0", description: "заробітня плата / wynagrodzenie / зп" },

            { name: t("debt"), value: `-${totalDebt.toFixed(2)}`, description: "борг / dług / долг" },
            { name: t("payment"), value: payout.toFixed(2), description: "на руки" },
        ];

        console.log("🔹 Оновлені фінальні дані для PDF:", updatedFinalData);
        const convertJsxToText = (jsxElement) => {
            if (!jsxElement) return "";

            if (typeof jsxElement === "string") return jsxElement;

            if (Array.isArray(jsxElement)) {
                return jsxElement.map(convertJsxToText).join(" ");
            }

            if (jsxElement.props && jsxElement.props.children) {
                return convertJsxToText(jsxElement.props.children);
            }

            return "";
        };

        // Використовуємо `updatedFinalData` у `renderTotal()`
        const renderTotal = () => {
            return {
                table: {
                    headerRows: 1,
                    widths: ["80%", "20%"], // 2 колонки: "Назва (опис)" | "Значення"
                    body: [
                        [{ text: `${t("total")} ${t("calculation").toLocaleLowerCase()}`, style: "tableHeader", colSpan: 2, alignment: "center" }, {}],
                        ...updatedFinalData.map((row) => [
                            {
                                text: Array.isArray(row.name) ? row.name.join("\n") : convertJsxToText(row.name).trim()
                            }, // Назва + Опис у дужках
                            { text: row.value.toString(), alignment: "right" } // Значення
                        ]),
                    ],
                },
                style: "table",
            };
        };

        const lastName = selectedUser.label.split(" ")[1] || selectedUser;
        const fileName = `raport-${lastName}-${weekNumber}.pdf`;

        const docDefinition = {
            content: [
                { text: `${selectedUser.label}`, style: "header" },
                { text: `${t("week")}: ${weekNumber}`, style: "subheader" },
                "\n",
                renderSection("Uber", reportData.uber, fieldsForPDF.uber, "uber"),
                renderSection("Bolt", reportData.bolt, fieldsForPDF.bolt, "bolt"),
                renderSection("FreeNow", reportData.freenow, fieldsForPDF.freenow, "freenow"),
                renderTotal(), // ✅ Додаємо виплату
            ],
            styles: {
                header: { fontSize: 18, bold: true, alignment: "center" },
                subheader: { fontSize: 14, margin: [0, 10, 0, 5] },
                table: { margin: [0, 5, 0, 15] },
                tableHeader: { bold: true, fontSize: 12, color: "black" },
            },
        };
        console.log(extraFunds.other_expenses);
        pdfMake.createPdf(docDefinition).download(fileName);
    };

    const renderSection = (title, data, fields, service) => {
        if (!data || data.length === 0) return { text: "" };

        // Отримуємо значення податку та загальної суми
        const tax = taxData[service]?.tax?.toFixed(2) || "0";
        const total = taxData[service]?.total?.toFixed(2) || "0";

        return {
            table: {
                headerRows: 1,
                widths: ["80%", "20%"], // Однакові ширини колонок
                body: [
                    [{ text: title, style: "tableHeader", colSpan: 2, alignment: "center" }, {}],
                    ...fields.map((key) => {
                        if (data[0] && data[0][key] !== undefined) {
                            const value = data[0][key] !== null ? data[0][key].toString() : "—";
                            const columnInfo = customColumnNames[service]?.[key] || {}; // Отримуємо назву

                            return [
                                {
                                    text: columnInfo.name || customColumnNames[service]?.[key] || key
                                }, // Назва + Опис у дужках
                                { text: value, alignment: "right" } // Значення вирівняне вправо
                            ];
                        }
                        return null;
                    }).filter(Boolean),

                    // 🔹 Додаємо Податок 4%
                    [{ text: `${t("taxes")} VAT  4%`, bold: true }, { text: `-${tax}`, alignment: "right" }],

                    // 🔹 Додаємо підсумкову суму
                    [{ text: t("total"), bold: true }, { text: total, alignment: "right" }],
                ],
            },
            style: "table",
        };
    };
    const handleSaveDraft = async () => {
        if (!selectedUser || !weekNumber || !reportData) {
            alert("⚠️ Спочатку згенеруй рапорт");
            return;
        }

        const payout =
            (taxData.uber.total || 0) +
            (taxData.bolt.total || 0) +
            (taxData.freenow.total || 0) -
            (parseFloat(totalDebt)) +
            (parseFloat(extraFunds.returnVAT) || 0) -
            (
                (parseFloat(extraFunds.taxesZUS) || 0) +
                (parseFloat(extraFunds.partner) || 0) +
                (parseFloat(extraFunds.accountant) || 0) +
                (parseFloat(extraFunds.carRent) || 0) +
                (parseFloat(extraFunds.sallary) || 0) +
                (parseFloat(extraFunds.other) || 0) -
                (parseFloat(extraFunds.refunds) || 0)
            );


        const payload = {
            driver_id: selectedUser.value,
            week_number: weekNumber,
            report_data: {
                report: reportData,
                extraFunds,
                selectedDebts,
                totalDebt,
                taxData,
                payout: payout.toFixed(2)
            }
        };
        const token = localStorage.getItem("token"); // 🔐 Отримуємо токен

        try {
            const response = await fetch("https://godrive.com.pl/api/save-report", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}` // ✅ Додаємо токен
                },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                const result = await response.json(); // ⬅️ Отримаємо повідомлення з відповіді
                alert(result.message || "✅ Рапорт збережено як чернетку");
            } else {
                const error = await response.json();
                console.error("❌", error);
                alert("❌ Не вдалося зберегти рапорт");
            }
        } catch (error) {
            console.error("❌", error);
            alert("❌ Сталася помилка при збереженні");
        }
    };
    // Функція для отримання дат тижня
    const getWeekDates = (weekNumber) => {
        if (!weekNumber) return "";

        const currentYear = new Date().getFullYear();

        // Знаходимо перший понеділок поточного року
        let firstDayOfYear = new Date(currentYear, 0, 1);
        while (firstDayOfYear.getDay() !== 1) { // 1 - це понеділок
            firstDayOfYear.setDate(firstDayOfYear.getDate() + 1);
        }

        // Якщо запитаний тиждень - останній тиждень минулого року
        if (weekNumber === 0) {
            let lastYear = currentYear - 1;
            let lastYearLastWeekStart = new Date(lastYear, 11, 31); // 31 грудня минулого року

            while (lastYearLastWeekStart.getDay() !== 1) { // Шукаємо останній понеділок
                lastYearLastWeekStart.setDate(lastYearLastWeekStart.getDate() - 1);
            }

            let lastYearLastWeekEnd = new Date(lastYearLastWeekStart);
            lastYearLastWeekEnd.setDate(lastYearLastWeekStart.getDate() + 6);

            return `${lastYearLastWeekStart.toLocaleDateString("uk-UA")} - ${lastYearLastWeekEnd.toLocaleDateString("uk-UA")}`;
        }

        // Розраховуємо початок тижня
        let weekStart = new Date(firstDayOfYear);
        weekStart.setDate(firstDayOfYear.getDate() + (weekNumber - 1) * 7);

        let weekEnd = new Date(weekStart);
        weekEnd.setDate(weekStart.getDate() + 6);

        return `${weekStart.toLocaleDateString("uk-UA")} - ${weekEnd.toLocaleDateString("uk-UA")}`;
    };


    const reportDates = getWeekDates(weekNumber);

    // Функція для рендерингу 2-колонкової таблиці
    const renderTable = (title, data, service) => {
        if (!data || data.length === 0) return null; // ❌ Не рендеримо таблицю, якщо даних немає

        let totalInc = parseFloat(data[0]?.inc_netto) || 0;
        let tax = totalInc * 0.04;
        let finalAmount = totalInc - tax;

        const columnDescriptions = {
            incBrutto: t("brutto"),
            brutto: t("brutto"),
            appFee: t("fee"),
            appFeeTaxes: t("taxes"),
            incCash: t("cash"),
            tips: t("tips"),
            bonus: t("bonus"),
            cash: t("cash"),
            sallary: t("sallary"),
            inc_netto: t("netProfit"),
            app_fee: `${t("total")} ${t("service").toLocaleLowerCase()} ${t("fee").toLocaleLowerCase()} `,
            saldo_freenow: t("balance"),
            totalInc: t("balance"),
            incNettoCash: t("cash"),
            incNetto: t("balance"),
        };




        return (
            <div className="mt-4 text-center">
                <h3 className="text-primary">{title}</h3>
                <table className="table table-bordered text-center" style={{ margin: "auto" }}>
                    <tbody>
                        {selectedFields[service].map((key, index) => {
                            if (!(key in data[0])) return null; // Якщо поля немає, не додаємо в таблицю

                            let value = data[0][key];
                            if (negativeFields[service]?.includes(key) && value > 0) {
                                value = `-${value}`;
                            }

                            return (
                                <tr key={index}>
                                    <td className="fw-bold" style={{ width: "70%" }}>{columnNames[service][key] || key}

                                    </td>
                                    <td style={{ width: "30%" }}>{value}</td>
                                </tr>
                            );
                        })}

                        {/* 🔹 Додаємо Податок 4% та Загалом тільки для Bolt */}
                        {service === "uber" && (
                            <>
                                <tr>
                                    <td className="fw-bold">{t("taxes")} VAT 4%
                                    </td>
                                    <td>-{taxData.uber.tax.toFixed(2)}</td>
                                </tr>
                                <tr>
                                    <td className="fw-bold">{t("total")}

                                    </td>
                                    <td>{taxData.uber.total.toFixed(2)}</td>
                                </tr>
                            </>
                        )}

                        {service === "bolt" && (
                            <>
                                <tr>
                                    <td className="fw-bold">{t("taxes")} VAT 4%

                                    </td>
                                    <td>-{taxData.bolt.tax.toFixed(2)}</td>
                                </tr>
                                <tr>
                                    <td className="fw-bold">{t("total")}

                                    </td>
                                    <td>{taxData.bolt.total.toFixed(2)}</td>
                                </tr>
                            </>
                        )}

                        {service === "freenow" && (
                            <>
                                <tr>
                                    <td className="fw-bold">{t("taxes")} VAT 4%</td>
                                    <td>-{taxData.freenow.tax.toFixed(2)}</td>
                                </tr>
                                <tr>
                                    <td className="fw-bold">{t("total")}</td>
                                    <td>{taxData.freenow.total.toFixed(2)}</td>
                                </tr>
                            </>
                        )}

                    </tbody>
                </table>
            </div>
        );
    };

    const renderFinalTable = () => {
        if (!reportData) return null; // ❌ Не рендеримо таблицю, якщо немає даних

        const boltTotal = taxData.bolt.total || 0;
        const uberTotal = taxData.uber.total || 0;
        const freenowTotal = taxData.freenow.total || 0;

        const payout =
            (boltTotal || 0) +
            (uberTotal || 0) +
            (freenowTotal || 0) -
            (parseFloat(totalDebt)) +
            (parseFloat(extraFunds.returnVAT) || 0) -
            ((parseFloat(extraFunds.taxesZUS) || 0) +
                (parseFloat(extraFunds.partner) || 0) +
                (parseFloat(extraFunds.accountant) || 0) +
                (parseFloat(extraFunds.carRent) || 0) +
                (parseFloat(extraFunds.sallary) || 0) +
                (parseFloat(extraFunds.other) || 0) -
                (parseFloat(extraFunds.refunds) || 0));

        const finalData = [
            { name: "Bolt", value: boltTotal.toFixed(2) },
            { name: "Uber", value: uberTotal.toFixed(2) },
            { name: "FreeNow", value: freenowTotal.toFixed(2) },
            { name: `${t("return")} ${t("vat")}`, value: extraFunds.returnVAT, description: "повернення VAT / zwrot VAT / возврат VAT" },
            { name: `${t("taxes")} ${t("zus")}`, value: extraFunds.taxesZUS ? `-${extraFunds.taxesZUS}` : "0", description: "податки + ЗУС / podatki + ZUS / налоги + ЗУС" },
            { name: t("partner"), value: extraFunds.partner ? `-${extraFunds.partner}` : "0", description: "партнер / partner / партнер" },
            { name: t("accountant"), value: extraFunds.accountant ? `-${extraFunds.accountant}` : "0", description: "бухгалтер / księgowy / бухгалтер" },
            { name: t("carRent"), value: extraFunds.carRent ? `-${extraFunds.carRent}` : "0", description: "оренда авто / wynajem samochodu / аренда авто" },
            { name: t("other"), value: extraFunds.other ? `-${extraFunds.other}` : "0", description: "інше / inne / другое " },
            { name: t("refunds"), value: extraFunds.refunds ? `${extraFunds.refunds}` : "0", description: "повернення / zwrot / возврат" }, // Refunds НЕ від’ємний
            { name: t("sallary"), value: extraFunds.sallary ? `${extraFunds.sallary}` : "0", description: "заробітня плата / wynagrodzenie / зп" },
            { name: t("debt"), value: `-${totalDebt.toFixed(2)}`, description: "борг / dług / долг" },
            { name: t("payment"), value: payout.toFixed(2), description: "на руки" },
        ];


        return (
            <div className="mt-4 text-center">
                <h3 className="text-danger">{t("total")} {t("calculation").toLocaleLowerCase()}</h3>
                <table className="table table-bordered text-center" style={{ margin: "auto" }}>
                    <tbody>
                        {finalData.map((row, index) => (
                            <tr key={index}>
                                <td className="fw-bold" style={{ width: "70%" }}>{row.name}
                                </td>
                                <td style={{ width: "30%" }}>{row.value}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                {payout < 0 && selectedUser && (
                    <div className="mt-3">
                        <a
                            href={`/admin/driver-debts?openModal=true&driverId=${selectedUser.value}&week=${weekNumber}&sum=${Math.abs(payout.toFixed(2))}&name=${encodeURIComponent(`Борг за тиждень ${weekNumber}`)}&desc=${encodeURIComponent(`Автоматичний борг, сума виплати за тиждень ${weekNumber} = ${payout.toFixed(2)} PLN`)}`}
                            className="btn btn-danger"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            🔗 {t("create")} {t("debt").toLocaleLowerCase()} {Math.abs(payout.toFixed(2))} PLN
                        </a>
                    </div>
                )}

            </div>

        );

    };

    return (
        <div className="container mt-4">
            <h2 className="mb-4 text-center">{t("driver")} {t("raport").toLocaleLowerCase()}</h2>

            <div className="row mb-3">
                <WeekSelector selectedWeek={weekNumber} setSelectedWeek={setWeekNumber} />

                <div className="col-md-3">
                    <Form.Group className="mb-3">

                        <DriverSelector selectedDriver={selectedUser} setSelectedDriver={setSelectedUser} />
                    </Form.Group>
                </div>
                <div className="col-md-3">
                    <button className="btn btn-primary w-100" onClick={fetchReport}>
                        {t("generate")} {t("raport").toLocaleLowerCase()}
                    </button>

                </div>
            </div>

            {loading && <p className="text-center">⏳ Завантаження...</p>}
            {reportData && hasExtraFunds !== null && (
                <div className="text-center mt-3">
                    {hasExtraFunds ? (
                        <div className="alert alert-success" role="alert">
                            ✅ {t("extraCosts")} {t("loaded").toLocaleLowerCase()}
                        </div>
                    ) : (
                        <div className="alert alert-danger" role="alert">
                            ❌ {t("noRecords")} {t("extraCosts").toLocaleLowerCase()}{" "}
                            <a
                                href={`/admin/edit-extra-funds?driver_id=${selectedUser?.value}&week_number=${weekNumber}`}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {t("create")}
                            </a>
                        </div>
                    )}
                </div>
            )}

            {reportData && (
                <div id="report-content">
                    {selectedUser && weekNumber && (
                        <div className="text-center mt-3">
                            <h4 className="text-primary">
                                {t("raport")} {t("for").toLocaleLowerCase()} <strong>{selectedUser.label}</strong> {t("by").toLocaleLowerCase()} <strong>{reportDates}</strong>
                            </h4>
                        </div>
                    )}
                    {renderTable("Uber", reportData.uber, "uber")}
                    {renderTable("Bolt", reportData.bolt, "bolt")}
                    {renderTable("FreeNow", reportData.freenow, "freenow")}
                    {renderFinalTable()}
                </div>
            )}

            {reportData && (
                <div className="text-center mt-3">
                    <button className="btn btn-success" onClick={downloadPDF}>
                        {t("download")} PDF
                    </button>
                    <button className="btn btn-warning" onClick={handleSaveDraft}>
                        💾 {t("save")} {t("draft").toLocaleLowerCase()}
                    </button>
                </div>
            )}
            {/* 🔹 МОДАЛЬНЕ ВІКНО ДЛЯ БОРГІВ */}
            {showDebtModal && (
                <div className="modal show d-block" tabIndex="-1">
                    <div className="modal-dialog">
                        <div className="modal-content bg-danger text-white">
                            <div className="modal-header">
                                <h5 className="modal-title">{t("debtsMulti")}</h5>
                                <button type="button" className="btn-close" onClick={() => setShowDebtModal(false)}></button>
                            </div>
                            <div className="modal-body">
                                {debts.length > 0 ? (
                                    <ul className="list-group">
                                        {debts.map((debt) => (
                                            <li key={debt.id} className="list-group-item d-flex justify-content-between align-items-center">
                                                <span>{debt.debt_name}: {Number(debt.debt_total).toFixed(2)}</span>
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    checked={selectedDebts.includes(debt.id)}
                                                    onChange={() => toggleDebtSelection(debt)}
                                                />
                                            </li>
                                        ))}
                                    </ul>
                                ) : (
                                    <p>{t("noRecords")}</p>
                                )}
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-primary" onClick={applySelectedDebts}>
                                    {t("add")} {t("debt").toLocaleLowerCase()}
                                </button>
                                <button type="button" className="btn btn-secondary" onClick={() => setShowDebtModal(false)}>
                                    {t("close")}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}


        </div>
    );
};

export default DriverRaport;
